/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const DiscountTagFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.9947 2.0605C12.9741 1.85638 11.919 2.17584 11.183 2.9118L2.45587 11.639C1.84804 12.2468 1.84804 13.2323 2.45587 13.8401L10.1599 21.5441C10.7677 22.152 11.7532 22.152 12.361 21.5441L21.0882 12.817C21.8242 12.081 22.1436 11.0259 21.9395 10.0053L20.8189 4.40212C20.6956 3.78598 20.214 3.30437 19.5979 3.18114L13.9947 2.0605ZM14.5858 9.41422C15.3668 10.1953 16.6332 10.1953 17.4142 9.41422C18.1953 8.63317 18.1953 7.36684 17.4142 6.58579C16.6332 5.80474 15.3668 5.80474 14.5858 6.58579C13.8047 7.36684 13.8047 8.63317 14.5858 9.41422Z'
      fill='currentColor'
    />
  </React.Fragment>
)
